// eslint-disable-next-line no-unused-vars
import { getEnv } from '@config';

const { publicPath } = getEnv();

export const advancementStatus = {
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED',
  ERROR: 'ERROR',
};

export const advancementErrorCode = {
  INVALID_ADVANCEMENT_AMOUNT: '2000',
};

export const advancementErrorContentByCode = {
  [advancementErrorCode.INVALID_ADVANCEMENT_AMOUNT]: {
    titleKey: 'homeScreen.advancementStatus.blocked.title',
    subTitleKey: 'homeScreen.advancementStatus.blocked.subTitle',
    iconPath: `${publicPath}/ils_error.svg`,
    alt: 'error',
  },
};

export const getAdvancementErrorContent = (errorCode, t) => {
  const errorContent = advancementErrorContentByCode[errorCode];
  if (errorContent) {
    return {
      title: t(errorContent.titleKey),
      subTitle: t(errorContent.subTitleKey),
      iconPath: errorContent.iconPath,
      alt: errorContent.alt,
    };
  }

  return {
    title: t('homeScreen.advancementStatus.error.title'),
    subTitle: t('homeScreen.advancementStatus.error.subTitle'),
    iconPath: `${publicPath}/warning.svg`,
    alt: 'warning',
  };
};
